import { getCorpus as getCorpus_1 } from "./corpora/amharic/Client/ZCore.js";
import { getCorpus as getCorpus_2 } from "./corpora/bb/Client/ZCore.js";
import { getCorpus as getCorpus_3 } from "./corpora/bokmal/Client/ZCore.js";
import { getCorpus as getCorpus_4 } from "./corpora/bokselskap/Client/ZCore.js";
import { getCorpus as getCorpus_5 } from "./corpora/cans3/Client/ZCore.js";
import { getCorpus as getCorpus_6 } from "./corpora/cans4/Client/ZCore.js";
import { getCorpus as getCorpus_7 } from "./corpora/digsos/Client/ZCore.js";
import { getCorpus as getCorpus_8 } from "./corpora/kindergarten/Client/ZCore.js";
import { getCorpus as getCorpus_9 } from "./corpora/lia_norsk/Client/ZCore.js";
import { getCorpus as getCorpus_10 } from "./corpora/liatrebanken/Client/ZCore.js";
import { getCorpus as getCorpus_11 } from "./corpora/ndc2/Client/ZCore.js";
import { getCorpus as getCorpus_12 } from "./corpora/ndctrebanken/Client/ZCore.js";
import { getCorpus as getCorpus_13 } from "./corpora/ndt_bm/Client/ZCore.js";
import { getCorpus as getCorpus_14 } from "./corpora/ndt_nn/Client/ZCore.js";
import { getCorpus as getCorpus_15 } from "./corpora/norint_tekst/Client/ZCore.js";
import { getCorpus as getCorpus_16 } from "./corpora/norm/Client/ZCore.js";
import { getCorpus as getCorpus_17 } from "./corpora/norpol/Client/ZCore.js";
import { getCorpus as getCorpus_18 } from "./corpora/nota_oslo/Client/ZCore.js";
import { getCorpus as getCorpus_19 } from "./corpora/nowac_1_1/Client/ZCore.js";
import { getCorpus as getCorpus_20 } from "./corpora/nynorsk/Client/ZCore.js";
import { getCorpus as getCorpus_21 } from "./corpora/run/Client/ZCore.js";
import { getCorpus as getCorpus_22 } from "./corpora/saami/Client/ZCore.js";
import { getCorpus as getCorpus_23 } from "./corpora/taus3/Client/ZCore.js";
import { getCorpus as getCorpus_24 } from "./corpora/trawl_de/Client/ZCore.js";
import { getCorpus as getCorpus_25 } from "./corpora/trawl_en/Client/ZCore.js";
import { getCorpus as getCorpus_26 } from "./corpora/trawl_es/Client/ZCore.js";
import { getCorpus as getCorpus_27 } from "./corpora/trawl_fr/Client/ZCore.js";
import { getCorpus as getCorpus_28 } from "./corpora/trawl_no/Client/ZCore.js";
import { toFail } from "../fable_modules/fable-library.3.7.9/String.js";

export function getCorpus(config) {
    const matchValue = config.Code;
    switch (matchValue) {
        case "amharic": {
            return getCorpus_1(config);
        }
        case "bb": {
            return getCorpus_2(config);
        }
        case "bokmal": {
            return getCorpus_3(config);
        }
        case "bokselskap": {
            return getCorpus_4(config);
        }
        case "cans3": {
            return getCorpus_5(config);
        }
        case "cans4": {
            return getCorpus_6(config);
        }
        case "digsos": {
            return getCorpus_7(config);
        }
        case "kindergarten": {
            return getCorpus_8(config);
        }
        case "lia_norsk": {
            return getCorpus_9(config);
        }
        case "liatrebanken": {
            return getCorpus_10(config);
        }
        case "ndc2": {
            return getCorpus_11(config);
        }
        case "ndctrebanken": {
            return getCorpus_12(config);
        }
        case "ndt_bm": {
            return getCorpus_13(config);
        }
        case "ndt_nn": {
            return getCorpus_14(config);
        }
        case "norint_tekst": {
            return getCorpus_15(config);
        }
        case "norm": {
            return getCorpus_16(config);
        }
        case "norpol": {
            return getCorpus_17(config);
        }
        case "nota_oslo": {
            return getCorpus_18(config);
        }
        case "nowac_1_1": {
            return getCorpus_19(config);
        }
        case "nynorsk": {
            return getCorpus_20(config);
        }
        case "run": {
            return getCorpus_21(config);
        }
        case "saami": {
            return getCorpus_22(config);
        }
        case "taus3": {
            return getCorpus_23(config);
        }
        case "trawl_de": {
            return getCorpus_24(config);
        }
        case "trawl_en": {
            return getCorpus_25(config);
        }
        case "trawl_es": {
            return getCorpus_26(config);
        }
        case "trawl_fr": {
            return getCorpus_27(config);
        }
        case "trawl_no": {
            return getCorpus_28(config);
        }
        default: {
            return toFail(`Unknown corpus: ${config.Code}`);
        }
    }
}

